export function applyDrag(arr, removedIndex, addedIndex) {
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];

  let itemToAdd;
  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/utils/dnd.js